import React from 'react';
import columns from './columns';
import Table from '../../../../components/_table/Table';
import Panel from '../../../../components/outline/Panel';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { VERSION_LIST_SORT_OPTION_MODEL } from '../../../../store/modules/version/model';
import './VersionList.scss';

const VersionList = (props) => {
  const { versionList, getList } = props;
  const { list, sortOption, pagination } = versionList;

  return (
    <div className="version-list">
      <Panel>
        <div className="panel-body">
          <Table
            list={list}
            scroll={{ x: true }}
            rowKey={(record) => record.id}
            initialOption={{
              sortOption: VERSION_LIST_SORT_OPTION_MODEL,
              pagination: LIST_PAGINATION_MODEL,
            }}
            size="small"
            getList={getList}
            sortOption={sortOption}
            pagination={pagination}
            columns={() =>
              columns({
                sortOption,
              })
            }
          />
        </div>
      </Panel>
    </div>
  );
};

export default VersionList;
